import {
  FeedTableData,
  FeedTableRow,
  FeedApiData,
  Parameters,
  FeedProductionResponse,
} from '@app/models/pr_feed/FeedResponse';
import { post, get } from './http.api';
import { FeedRequest } from '@app/models/pr_feed/FeedRequest';

export const getFeedData = async (parameters: Parameters): Promise<FeedTableData> => {
  try {
    const { data, status } = await get<any>(
      'pr_feed_productions',
      {
        params: parameters,
      },
      true,
    );
    console.log(`Status: ${status}`, `Data:`, data);
    const feedProductions: FeedTableRow[] = data.pr_feed_productions.data.map((feedData: any) => ({
      id: feedData.id,
      year: feedData.year,
      status: feedData.status,
    }));

    return {
      data: feedProductions,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Product Registrations:', error);
    throw error;
  }
};

export const getAllFeedRegistrations = async (): Promise<FeedProductionResponse> => {
  try {
    const { data, status } = await get<FeedProductionResponse>(`pr_feed_productions`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getFeedById = async (id: number): Promise<FeedProductionResponse> => {
  try {
    const { data, status } = await get<FeedProductionResponse>(`pr_feed_productions/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeFeed = async (feedData: FeedRequest) => {
  try {
    const response = await post<any>('pr_feed_productions/create', feedData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createFeed = async (): Promise<FeedApiData> => {
  try {
    const { data, status } = await get<FeedApiData>(`pr_feed_productions/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showFeed = async (id: number) => {
  try {
    const { data, status } = await get<FeedApiData>(`feed_productions/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editFeed = async (id: number) => {
  try {
    const { data, status } = await get<FeedApiData>(`feed_productions/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateFeed = async (id: number, UpdateFeed: FeedRequest) => {
  try {
    const { data, status } = await post<FeedRequest>(`feed_productions/${id}/edit`, UpdateFeed, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
